// Browsers block cross origin calls to ERPNext/Frappe servers (CORS), so
// Frappe API requests are routed through the same origin /erp-proxy endpoint.
const PROXY_PREFIX = "/erp-proxy";
const nativeFetch = window.fetch.bind(window);

const isLanHost = host =>
  /^(localhost|127\.|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(host) ||
  /\.local$/.test(host);

export function proxiedUrl(rawUrl, method) {
  let url;
  try {
    url = new URL(rawUrl, window.location.href);
  } catch (e) {
    return null;
  }
  if (url.origin === window.location.origin) {
    return null;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") {
    return null;
  }
  if (isLanHost(url.hostname)) {
    return null;
  }
  const isLogin =
    (url.pathname === "/" || url.pathname === "") && method === "POST";
  if (!isLogin && !url.pathname.startsWith("/api/")) {
    return null;
  }
  const scheme = url.protocol.replace(":", "");
  return `${PROXY_PREFIX}/${scheme}/${url.host}${url.pathname}${url.search}`;
}

window.fetch = function(input, init) {
  const isRequest = typeof Request !== "undefined" && input instanceof Request;
  const rawUrl = isRequest ? input.url : String(input);
  const method = (
    (init && init.method) ||
    (isRequest && input.method) ||
    "GET"
  ).toUpperCase();
  const target = proxiedUrl(rawUrl, method);
  if (!target || isRequest) {
    return nativeFetch(input, init);
  }
  return nativeFetch(
    target,
    Object.assign({}, init, { credentials: "same-origin" }),
  );
};
